export const WATER_READ_TYPE = {
	ACTUAL: "A",
	ESTIMATE: "E",
} as const;

export type WaterReadType =
	(typeof WATER_READ_TYPE)[keyof typeof WATER_READ_TYPE];

export const WATER_READ_TYPE_LABEL: Record<WaterReadType, string> = {
	[WATER_READ_TYPE.ACTUAL]: "Actual",
	[WATER_READ_TYPE.ESTIMATE]: "Estimate",
};

export interface WaterBill {
	BillId: number;
	WaterAccountId: number;
	AccountNumber: string;
	Location: string | null;
	ServicePeriodStart: Date;
	ServicePeriodEnd: Date;
	TotalGallons: number | null;
	TrackedGallons: number | null;
	BalanceForward: number | null;
	CurrentBill: number | null;
	CostPerGallon: number | null;
	AmountDue: number | null;
	CheckNumber: string | null;
	PayDate: Date | null;
	IsPaid: boolean;
	Comments: string | null;
	MeterCount: number;
}

export interface WaterBillMeter {
	BillId: number;
	MeterId: number;
	ExternalMeterId: string;
	MeterNumber: string;
	MeterSize: string | null;
	AssetId: number | null;
	MillName: string | null;
	Gallons: number | null;
	TrackedGallons: number | null;
	StartReadType: WaterReadType | null;
	EndReadType: WaterReadType | null;
	StartDate: Date;
	EndDate: Date;
	IsDateOverridden: boolean;
}

export interface WaterBillAllocation {
	BillId: number;
	TargetId: number;
	TargetCode: string;
	TargetName: string;
	AssetId: number | null;
	AllocationPercent: number;
	AllocatedGallons: number | null;
	AllocatedAmount: number | null;
	DisplayOrder: number | null;
}

export interface WaterBillTarget {
	TargetId: number;
	TargetCode: string;
	TargetName: string;
	IsVisible: boolean;
}

export interface WaterBillsData {
	bills: WaterBill[];
	meters: WaterBillMeter[];
	allocations: WaterBillAllocation[];
	targets: WaterBillTarget[];
}

export interface WaterBillTrackedGallons {
	byMeterId: Record<number, number | null>;
	total: number | null;
}

export interface WaterBillDraft {
	BillId: number | null;
	WaterAccountId: number;
	ServicePeriodStart: Date | null;
	ServicePeriodEnd: Date | null;
	BalanceForward: number | null;
	CurrentBill: number | null;
	CheckNumber: string | null;
	PayDate: Date | null;
	Meters:
		| {
				MeterId: number;
				Gallons: number | null;
				StartReadType: WaterReadType | null;
				EndReadType: WaterReadType | null;
		  }[]
		| null;
	Allocations:
		| {
				TargetCode: string;
				AllocationPercent: number;
		  }[]
		| null;
}
